import axios from 'axios'
import endpoints from '../../endpoints'

const API_URL = process.env.REACT_APP_API_URL || ''

export async function uploadNFC(file: any) {
  try {
    const response = await axios.post(API_URL + endpoints.nfc.bulkUpload, file)
    return response.data
  } catch (error) {
    console.error('Error sending message:', error)
    throw error
  }
}
